import { Component, OnInit, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

@Component({
  selector: 'app-delete-modal',
  templateUrl: './delete-modal.component.html',
  styleUrls: ['./delete-modal.component.css']
})
export class DeleteModalComponent implements OnInit, OnChanges {

  @Input() title: string;
  @Input() deleted: boolean;
  @Input() isStaff: boolean = false;
  @Input() text = 'DELETE';
  @Input() isCustomMessage: boolean = false;
  @Input() customMessage = "Type " + this.text + " in all caps to confirm deletion.";

  @Output() close: EventEmitter<void> = new EventEmitter();
  @Output() confirm: EventEmitter<void> = new EventEmitter();

  form: FormGroup;
  isConfirmWarning: boolean;
  loading: boolean;

  constructor(
    private fb: FormBuilder
  ) {
    this.form = this.fb.group({
      confirm: [null, [Validators.required, Validators.pattern(/^[a-zA-Z ]+$/)]]
    });
  }

  ngOnInit() {
  }

  ngOnChanges(data) {
    if (data.deleted && this.deleted) {
      this.loading = false;
      this.close.emit();
    }
  }

  closePopup(event: Event) {
    event.stopPropagation();
    event.preventDefault();

    this.close.emit();
  }

  onPopUpConfirm(event, confirmWithText) {
    event.stopPropagation();
    event.preventDefault();

    const flag = this.isDeleteTextMatched(confirmWithText);
    if (flag) {
      this.isConfirmWarning = false;
      this.loading = true;
      this.form.reset();
      this.confirm.emit();
    } else {
      this.isConfirmWarning = true;
    }
  }

  isConfirmDeleteValid() {
    return this.form.get('confirm').errors
      && (this.form.get('confirm').touched
        || this.form.get('confirm').dirty);
  }

  isDeleteTextMatched(confirmWithText) {
    const val = this.form.controls.confirm.value;
    if (val) {
      return (val.trim() === confirmWithText) ? true : false;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/delete-modal/delete-modal.component.ts